import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import useLiveData from 'hooks/useLiveData';

export const useThreshold360Query = ({ id }) => {
	const staticData = useStaticQuery(graphql`
		{
			allSmartTagsThreshold360(
				filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
			) {
				edges {
					node {
						id
						title
						thresholdId
					}
				}
			}
		}
	`);

	const threshold360Edges = staticData?.allSmartTagsThreshold360?.edges || [];
	const threshold360Node = threshold360Edges.find(edge => edge?.node?.id === id)?.node || null;

	const {
		statusText: thresholdStatusText,
		response: thresholdResponse,
		visibilityChange: thresholdVisibilityChange
	} = useLiveData({
		namespace: 'SmartTags',
		model: 'Threshold360',
		method: 'all',
		graphqlKey: 'allSmartTagsThreshold360',
		apiParams: {
			approved: true,
			archived: false,
			deleted: false,
			_join: 'Audience',
			...(!!id ? { id } : {})
		}
	});

	const liveThreshold360 = thresholdResponse?.data.find(item => item?.id === id);
	let threshold360 = threshold360Node;
	if (!!liveThreshold360 && thresholdStatusText === 'LOADED') {
		threshold360 = liveThreshold360;
	}
	if (!!liveThreshold360 && thresholdVisibilityChange) threshold360 = liveThreshold360;

	const data = React.useMemo(() => ({
		title: threshold360?.title,
		id: threshold360?.thresholdId,
	}), [threshold360]);

	return { data };
};